import { GetAdminTripItineraryImportsResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

/**
 * Fetches every itinerary import on one trip (GET /v1/admin/trips/:id/itinerary-imports)
 * for the admin trip detail. Ignores the global date range — it is the trip's whole
 * history. Disabled until the id is a valid positive number. Gated server-side by
 * AdminGuard.
 */
export const useAdminTripItineraryImports = (tripId: number) => {
	return useQuery<GetAdminTripItineraryImportsResponse>({
		queryKey: queryKeys.adminTripItineraryImports(tripId),
		queryFn: async () => {
			const response = await api.get<GetAdminTripItineraryImportsResponse>(
				`/admin/trips/${tripId}/itinerary-imports`,
			)
			return response.data
		},
		enabled: Number.isFinite(tripId) && tripId > 0,
	})
}
